export const SectionHeader = ({
  icon: IconComp,
  label,
  action,
  style,
  fontSize,
  marginBottom,
  paddingBottom,
}) => (
  <div
    className="section-header"
    style={{
      ...(fontSize != null && { '--section-header-font-size': `${fontSize}px` }),
      ...(marginBottom != null && { marginBottom: `${marginBottom}px` }),
      ...(paddingBottom != null && { paddingBottom: `${paddingBottom}px` }),
      ...style,
    }}
  >
    <div className="section-header__left">
      {IconComp && (
        <span className="section-header__icon">
          <IconComp size={16} />
        </span>
      )}
      <span className="section-header__label">{label}</span>
    </div>
    {action}
  </div>
)

export default SectionHeader
